// Latest Buyer Pop
$(document).ready(function() {
    $('.latest-buyer .item').addClass("down").removeClass("up");
    setTimeout(upNextBuyerItem, 6000);
});

function generateBuyer(){
    var purchaseTime = Math.floor(Math.random() * 28) + 2;
    var packageNum = [1,3,5];
    var packageBought = packageNum[Math.floor(Math.random()*packageNum.length)];
    var newBuyerImage = '/dist/images/'+ packageBought + 'pack-slider.png';

    $('.buyer-name').text(faker.name.firstName());
    $('.buyer-location').text(faker.address.city() + ', ' + faker.address.stateAbbr());
    $('.buyer-time').text(purchaseTime);
    $('.buyer-purchase').text(packageBought);
    $('.buyer-img').attr('src', newBuyerImage);
}

function downAllBuyerItem() {
    $('.latest-buyer .item').addClass("down").removeClass("up");
    setTimeout(upNextBuyerItem, 20000);
}

function upNextBuyerItem() {
    generateBuyer();
    $('.latest-buyer .item').addClass("up").removeClass("down");
    setTimeout(downAllBuyerItem, 4500);
}
$(".close-tog").click(function(){
    $(".latest-buyer .item").removeClass("up");
    $(".latest-buyer .item").addClass("down");
});
